import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { Link, useLocation } from "react-router-dom";
import { SideBarRoutesList } from "../../../../constants";
import { SubModAppImages, Website_URL } from "../../../constants/constants";
import "./Sidebar.scss";

type SidebarProps = { open: boolean; onClose: () => void };

export const activeNavigationKey = (pathname: string, state?: any) => {
  const pathParts = pathname.split("/").filter(Boolean);
  const routeKeys = ["logs", "organization", "subscription", "order", "organizations", "settings", "quotes"];
  return pathParts.find(part => routeKeys.includes(part))
    || (state?.activeSideBar as string | undefined)
    || pathParts[pathParts.length - 1];
};

export const NavigationLinks = ({ onNavigate, horizontal = false }: { onNavigate?: () => void; horizontal?: boolean }) => {
  const location = useLocation();
  const activeKey = activeNavigationKey(location.pathname, location.state);

  return <List className={horizontal ? "top-navigation-links" : "mobile-navigation-links"}>
    {SideBarRoutesList.map(item => {
      const { text, to, icon: Icon, activeSideBar, child } = item as any;
      const active = activeKey === activeSideBar || activeKey === child;
      return <ListItemButton component={Link} to={to} key={text} state={{ activeSideBar }}
        selected={active} aria-current={active ? "page" : undefined} onClick={onNavigate}>
        {Icon && <ListItemIcon><Icon /></ListItemIcon>}
        <ListItemText primary={<Typography className="navLink">{text}</Typography>} />
      </ListItemButton>;
    })}
  </List>;
};

const Sidebar = ({ open, onClose }: SidebarProps) => <Drawer className="mobile-navigation-drawer"
  variant="temporary" open={open} onClose={onClose} ModalProps={{ keepMounted: true }}
  PaperProps={{ role: "dialog", "aria-label": "Application navigation" }}>
  <div className="mobile-navigation-header">
    <a href={Website_URL} className="logo">
      <img className="app-logo" alt="Managed Solution" src={SubModAppImages.logo} />
    </a>
    <IconButton aria-label="Close navigation" onClick={onClose}><CloseIcon /></IconButton>
  </div>
  <NavigationLinks onNavigate={onClose} />
</Drawer>;

export default Sidebar;
